import React, { createContext, useContext, useState, useEffect } from 'react';
import { getMiningUserData, getMiningAccessToken, removeMiningAccessToken, removeMiningUserData } from '../api/miningApi';

const MiningAuthContext = createContext(null);

export const MiningAuthProvider = ({ children }) => {
  const [miningUser, setMiningUser] = useState(null);
  const [miningToken, setMiningToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing session on mount
    const token = getMiningAccessToken();
    const user = getMiningUserData();

    if (token && user) {
      setMiningToken(token);
      setMiningUser(user);
    }
    setLoading(false);
  }, []);

  const loginMining = (token, user) => {
    setMiningToken(token);
    setMiningUser(user);
  };

  const logoutMining = () => {
    removeMiningAccessToken();
    removeMiningUserData();
    setMiningToken(null);
    setMiningUser(null);
  };

  const value = {
    miningUser,
    miningToken,
    loading,
    isAuthenticated: !!miningToken && !!miningUser,
    loginMining,
    logoutMining,
  };

  return (
    <MiningAuthContext.Provider value={value}>
      {children}
    </MiningAuthContext.Provider>
  );
};

export const useMiningAuth = () => {
  const context = useContext(MiningAuthContext);
  if (!context) {
    throw new Error('useMiningAuth must be used within MiningAuthProvider');
  }
  return context;
};
